import apiClient from '@/api/client';

export const PartnerRoleService = {
    async getAll(): Promise<PartnerRoleResponse> {
        const response = await apiClient.get<PartnerRoleResponse>('/partner/roles');
        const result = response.data

        if (!result) {
            throw new Error('Failed to retrieve roles.');
        }

        return result;
      }
}

export interface PartnerRoleResponse {
    roles: string[]
}